export default 
`{
  "gisapToken": "eyJ0***.eyJfdsowe***.xkV_ky***",
  "error": null
}`;
